import type { BookingSessionResponse } from '@massilia/queries'

import { InformationsForm } from './informations-form'
import { InformationsLoadingSkeleton } from './loading-skeleton'

interface InformationsPageProps {
  sessionId: string
  isLoading: boolean
  session?: BookingSessionResponse
}

export function InformationsPage({ sessionId, isLoading, session }: InformationsPageProps) {
  if (isLoading && !session) {
    return <InformationsLoadingSkeleton />
  }

  return <InformationsForm session={session} sessionId={sessionId} />
}
